import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinManageRoute: InvariantJiraRoute = {
	name: 'legacy-gin-manage',
	path: '(/secure/|/)ManageFilters.jspa',
};
